import { FC } from 'react'
import { ProviderAtDesk } from 'assets'
export const AdultCenterCriteria: FC = () => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="aspect-w-16 aspect-h-9 h-80 max-h-80">
        <img
          src={ProviderAtDesk}
          alt="Doctor talking with person at desk"
          className="object-cover w-full h-full"
        />
      </div>
      <div className="p-6">
        <h3 className="text-2xl font-serif text-[#3C2416] mb-4">
          Adult Center Criteria
        </h3>
        <div className="prose-text">
          <p className="text-[#3C2416] mb-6">
            The elements needed in a Sickle Cell center that treats adults to
            become a member of NASCC are as follows:
          </p>

          <div className="mb-6">
            <div className="font-bold text-[#3C2416] mb-2">
              Essential personnel requirements:
            </div>
            <ul className="ml-6 space-y-2 list-disc">
              <li className="text-[#3C2416]">
                Sickle Cell Specialist (physician)
              </li>
              <li className="text-[#3C2416]">
                Case Manager/Patient Navigator (or someone who fills this role)
              </li>
              <li className="text-[#3C2416]">Social Worker(s)</li>
              <li className="text-[#3C2416]">
                Educated Nursing Staff (for managing Sickle Cell disease)
              </li>
              <li className="text-[#3C2416]">
                Advanced Practice Providers (depending on size - not a
                requirement for centers)
              </li>
            </ul>
          </div>

          <div className="mb-6">
            <div className="font-bold text-[#3C2416] mb-2">
              Essential protocols and treatments available:
            </div>
            <ul className="ml-6 space-y-2 list-disc">
              <li className="text-[#3C2416]">
                Written procedures for acute/chronic management
              </li>
              <li className="text-[#3C2416]">
                Written procedures for pain management
              </li>
              <li className="text-[#3C2416]">
                Erythrocytopheresis for acute treatment
              </li>
              <li className="text-[#3C2416]">
                Erythrocytopheresis for chronic treatment
              </li>
              <li className="text-[#3C2416]">
                Timely access to transfusion medicine
              </li>
              <li className="text-[#3C2416]">
                Timely access to specialist services including family planning
              </li>
              <li className="text-[#3C2416]">
                Plan for mental health treatment if there is not a dedicated
                provider
              </li>
              <li className="text-[#3C2416]">
                Access to all approved SCD-modifying therapies
              </li>
            </ul>
          </div>

          <div>
            <div className="font-bold text-[#3C2416] mb-2">
              Optimal elements:
            </div>
            <ul className="ml-6 space-y-2 list-disc">
              <li className="text-[#3C2416]">Lead Nurse/Clinic Manager</li>
              <li className="text-[#3C2416]">Infusion Center/Day Hospital</li>
              <li className="text-[#3C2416]">GYN/Contraception Access</li>
              <li className="text-[#3C2416]">Transition Plan and Guidelines</li>
              <li className="text-[#3C2416]">Mental Health Staff</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdultCenterCriteria
